// Account pill + dropdown in the header. Profile / Manage subscription /
// Admin (super only) / Sign out / Delete account. Closes on outside click.
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useRole } from '../app/RoleContext';

const ROLE_LABEL = {
  member: 'Member', leader: 'Event & Group leader', 'group-leader': 'Group leader', 'event-leader': 'Event leader',
  publisher: 'Publisher', super: 'Superadmin',
};

export default function AccountMenu() {
  const { user, me, signOut } = useAuth();
  const { effectiveRole, pillRole } = useRole();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const name = me?.username && me.username !== me.email ? me.username : (me?.email || user?.email || '');
  const initials = (name || '?').trim().slice(0, 2).toUpperCase();

  const go = (path) => { setOpen(false); navigate(path); };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button className="account-pill" onClick={() => setOpen((o) => !o)}>
        <span className="av">{initials}</span>
        <span>{name}</span>
      </button>

      {open && (
        <div className="acc-menu">
          <div className="acc-h">
            <div className="nm">{name}</div>
            <div className="em">{me?.email || user?.email}</div>
            {pillRole !== 'member' && ROLE_LABEL[pillRole] && (
              <span className={`pill-role ${pillRole}`} style={{ marginLeft: 0, marginTop: 6, display: 'inline-block' }}>
                {ROLE_LABEL[pillRole]}
              </span>
            )}
          </div>
          <button className="acc-item" onClick={() => go('/profile')}>Profile</button>
          <button className="acc-item" onClick={() => go('/billing')}>Manage subscription</button>
          {effectiveRole === 'super' && (
            <button className="acc-item" style={{ color: 'var(--amber-text)', fontWeight: 600 }} onClick={() => go('/admin')}>
              ⚡ Admin tools
            </button>
          )}
          <div className="acc-divider" />
          <a className="acc-item" href="mailto:support@mediumnumber.com" onClick={() => setOpen(false)}
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            Help &amp; Support
          </a>
          <button className="acc-item" onClick={() => { setOpen(false); go('/terms'); }}>Terms &amp; Privacy</button>
          <div className="acc-divider" />
          <button className="acc-item" onClick={() => { setOpen(false); signOut(); }}>Sign out</button>
        </div>
      )}
    </div>
  );
}
